var _defs, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _g3, _path15, _path16, _g4, _path17, _path18, _path19, _g5, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g6, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g7, _path47, _path48, _path49, _path50, _path51, _path52, _g8, _g9, _g10, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g11, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _g12, _g13, _path69, _g14, _path70, _path71, _path72, _g15, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _g16, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g17, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _g18, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _g19, _path123, _g20, _g21, _path124, _g22, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_77",
    "data-name": "Group 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600.431,
    height: 439,
    viewBox: "0 0 600.431 439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 600.431,
    height: 439,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 14.27,
    height: 24.403,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 60.766,
    height: 74.622,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 60.478,
    height: 47.455,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 11.496,
    height: 15.702,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 7.737,
    height: 9.89,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M378.99,146.86c-8.6,3.19-12.243,14.808-8.127,25.9s14.457,17.521,23.053,14.332,12.243-14.808,8.127-25.9c-3.4-9.168-11.055-15.15-18.463-15.149a13.149,13.149,0,0,0-4.591.817",
    transform: "translate(-369.17 -146.043)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 58.971,
    height: 53.55,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 33.374,
    height: 18.762,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 16.531,
    height: 13.334,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 10.984,
    height: 23.003,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 20.665,
    height: 38.818,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 45.144,
    height: 30.803,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 16.925,
    height: 30.179,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 11.099,
    height: 23.62,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 13.496,
    height: 18.958,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 11.499,
    height: 22.456,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 56.765,
    height: 66.477,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 12.709,
    height: 18.792,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 33.739,
    height: 31.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 4.754,
    height: 3.447,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 13.937,
    height: 4.985,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 29.423,
    height: 32.41,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M145.11,204.8s-24.344-61.037-30-75.34c-7.04-17.815-21.594-40.583-12.575-45.719,10.179-5.8,13.651,19.954,20.623,45.161,2.906,10.507,25.307,73.72,25.486,74.25.442,1.315-2.85,3.378-3.538,1.649",
    transform: "translate(37.159 30.91)",
    fill: "#f07d18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M132.86,166.734c-.126.265-13.49,8.47-16.284,7.911s1.9-10.172,2.18-10.34,6.088-4.1,6.088-4.1,9.769,2.869,8.016,6.533",
    transform: "translate(43.129 59.722)",
    fill: "#ffb9a0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M126.293,171.338c-.209-.187-5.086-5.8-4.36-11.5s2.571-8.673,3.326-11.279c.342-1.178,2.431-1.223,2.6-.162.125.791.167,4.891.167,4.891l5.143-1.678,2.962,15.539s-6.6,7.1-9.837,4.191",
    transform: "translate(45.428 55.037)",
    fill: "#ffe5cf"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(167.289 202.671)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M126.293,171.338c-.209-.187-5.086-5.8-4.36-11.5s2.571-8.673,3.326-11.279c.342-1.178,2.431-1.223,2.6-.162.125.791.167,4.891.167,4.891l5.143-1.678,2.962,15.539s-6.6,7.1-9.837,4.191",
    transform: "translate(-121.86 -147.634)",
    fill: "#ffb9a0"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M129.9,157.837s-2.124,1.006-2.534,1.937.522,1.863,1.863,1.752a37.917,37.917,0,0,0,6.036-1.341c1.3-.448.708-2.943-.559-3.056a20.121,20.121,0,0,0-4.806.708",
    transform: "translate(47.446 58.571)",
    fill: "#ffe5cf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M127.6,157.105s-2.021,1.277-2.214,2.276.92,1.7,2.2,1.3a62.219,62.219,0,0,0,7.453-2.695c1.172-.723.014-3.195-1.257-3.2-1.958-.008-5.029,1.6-6.184,2.321",
    transform: "translate(46.736 57.702)",
    fill: "#ffe5cf"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M127.129,154.681s-2.058,1.292-2.258,2.3.932,1.717,2.239,1.306a63.867,63.867,0,0,0,7.589-2.733c1.194-.733.089-3.409-1.205-3.411-1.989,0-5.186,1.807-6.364,2.538",
    transform: "translate(46.543 56.718)",
    fill: "#ffe5cf"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M126.446,152.381s-1.6,1.192-1.712,2.2,1.065,1.613,2.32,1.1,5.171-1.953,6.289-2.779-.2-3.369-1.479-3.262c-1.963.165-4.319,1.916-5.418,2.739",
    transform: "translate(46.497 55.784)",
    fill: "#ffe5cf"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M6.294,298.613a29.953,29.953,0,0,0-4.75,5.294c-1.8,2.751.115,8.868,1.743,12.153s10.694,9.728,13.676,9.739,1.824-9.681,2.732-13.328a59.134,59.134,0,0,1,2.059-6.581,17.077,17.077,0,0,0-15.46-7.276",
    transform: "translate(0.305 111.3)",
    fill: "#070540"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M17.267,324.1c-2.98-.011-12.049-6.453-13.676-9.739C2.122,311.4.428,306.13,1.436,303.108c-.25.328-.489.664-.711,1-1.8,2.75.117,8.868,1.743,12.153s10.7,9.728,13.676,9.739c.862,0,1.377-.807,1.7-2.046a1.186,1.186,0,0,1-.574.144",
    transform: "translate(0 112.997)",
    fill: "#e6e8f4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M106.31,311.015a10.278,10.278,0,0,0,.678,3.133c.518.9,11.652,3.863,15.762,4.261,5.291.512,13.268-.5,13.72-1.767s-1.323-4.923-3.105-6.644-9.143-6.22-11.747-7.5-15,4.566-15.308,8.514",
    transform: "translate(39.632 112.703)",
    fill: "#070540"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M122.573,315.2c-4.11-.4-15.244-3.365-15.762-4.261a2.077,2.077,0,0,0,.349,1.492c.518.9,11.3,3.951,15.408,4.349,5.291.512,13.268-.5,13.72-1.767a2.691,2.691,0,0,0-.08-1.462c-.888,1.209-8.511,2.144-13.635,1.649",
    transform: "translate(39.808 115.915)",
    fill: "#e6e8f4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M67.237,196.128s-10.284,14.755-12.3,24.368-6.11,48.182-6.782,51.7c-.166.873-9.2,6.146-13.264,12.149-12.317,18.188-30.311,51-30.48,52.178-.222,1.565,13.63,4.086,15.587,8.85,3.491-2.888,42.607-55.955,47.235-61.163,4.945-5.565,22.356-30.757,22.356-30.757s34.3,33.44,35.995,35.9c.555.8.4,8.612,2.607,17.065,4.549,17.435,15.194,42.762,16.1,43.966,0,0,9.688-8.422,15.276-8.57,0,0-12.966-48.885-16.32-62.97s-30.181-62.63-33.087-66.3-40.135-16.192-42.925-16.416",
    transform: "translate(1.645 73.115)",
    fill: "#6b78b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(55.281 269.243)",
    opacity: 0.33,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M96.795,212.544c-2.906-3.672-40.134-16.192-42.924-16.416,0,0-10.284,14.755-12.3,24.368-.373,1.79-.821,4.585-1.3,7.968.005-.01,10.026-16.424,60.765-8.956-2.117-3.693-3.658-6.228-4.241-6.964",
    transform: "translate(-40.269 -196.128)",
    fill: "#6b78b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M77.641,226.589C74.063,231.1,66.462,242.3,66.462,242.3s8.752,8.532,17.631,17.294h0c-9.346-11.972-2.875-37.509-6.452-33",
    transform: "translate(-30.505 -184.969)",
    fill: "#6b78b7"
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M119.058,183.886s3.13,1.23,5.869-3.41S129.566,166,129.566,166l-12.742,3.521s-3.466,10.227,2.235,14.364",
    transform: "translate(43.162 61.884)",
    fill: "#acb3d8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M95.512,144.464c-5.928.062-21.109,3.963-26.29,11.531-7.6,11.1-4.732,29.213-10.209,37.486s-11.844,14.642-10.838,21.685,38.441,19.734,50.85,16.309c10.218-2.82,19.892-37.3,23.928-46.937,0,0,14.755,6.819,21.35,7.379,0,0-4.079-6.654.058-16.044s5.7-9.8,5.7-9.8-5.195.248-16.819-7.241S111.012,144.3,95.512,144.464",
    transform: "translate(17.919 53.854)",
    fill: "#e6e8f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(107.495 198.315)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M121.963,158.828c-11.625-7.49-22.223-14.527-37.723-14.364-2.785.029-9.632-.4-3.384,7.52,9.516,12.057,35.27,16.349,30.823,32.553,0,0,14.755,6.819,21.35,7.377,0,0-4.079-6.653.058-16.042s5.7-9.8,5.7-9.8-5.195.248-16.819-7.241",
    transform: "translate(-78.304 -144.461)",
    fill: "#e6e8f4"
  }))))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M79.629,190.885s1.781,1.322,14.692-11.309S87.726,169.236,82.7,173.2s-9.494,12.428-3.067,17.682",
    transform: "translate(28.496 63.4)",
    fill: "#acb3d8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M98.535,171.912s35.333-1.043,37.753-1.415,7.663-9.485,8.955-10.742,8.5-.253,9.4,0,.474,2.489.209,2.935c0,0,2.028.745,2.456,1.584.316.616-.335,2.608-.335,2.608s1.378.522,1.6,1.244a6.05,6.05,0,0,1-.373,1.811s1.6.671,1.435,2.012c-.106.853-2.2,3.107-3.159,2.876s-3.547-.494-4.655.3a2.371,2.371,0,0,0-1.148,2.566c.195.622-2.5,3.5-5.849,3.391s-7.526-1.621-15.257,1.844-24.108,6.316-30.591,6.372-15.7-6.372-15.817-6.372,8.794-10.809,15.381-11.01",
    transform: "translate(30.999 59.325)",
    fill: "#ffe5cf"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(179.148 218.465)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M140.548,169.937a6.014,6.014,0,0,0,.372-1.812c-.222-.722-1.6-1.244-1.6-1.244s.651-1.991.336-2.608c-.43-.837-2.456-1.583-2.456-1.583.264-.448.685-2.682-.209-2.935a34.167,34.167,0,0,0-6.491-.614c.608.051,3.07.354,3.584.977.531.642-.1,2.4.516,3.381a65.323,65.323,0,0,1,3.453,6.316c.419,1.174.224,4.688-1.538,4.775h0a10.49,10.49,0,0,1,2.313.233c.96.231,3.052-2.023,3.159-2.876.167-1.341-1.435-2.012-1.435-2.012",
    transform: "translate(-130.499 -159.139)",
    fill: "#ffb9a0"
  }))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M106.683,173.687c.025-.037-6.326-1.9-14.486-9.949s-19.9-11.578-25.264-7.913-9.283,15.076-.279,23.115c12.519,11.179,15.429,17.793,18.619,17.793,0,0-2.858-.634,5.749-8.57s12.6-9.892,15.659-14.476",
    transform: "translate(22.851 57.551)",
    fill: "#f3f4fa"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M86.076,155.478s2.347,1.1,3.469.469-.809-7.59-2.634-8.92-1.617,7.251-.835,8.451",
    transform: "translate(31.874 54.759)",
    fill: "#acb3d8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M93.176,142.257a6.332,6.332,0,0,1-5.2,3.674c-3.794.261.156-9.885.156-9.885h5.935a46.413,46.413,0,0,1-.887,6.212",
    transform: "translate(32.182 50.717)",
    fill: "#070540"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(118.507 186.762)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M93.176,142.257a6.332,6.332,0,0,1-5.2,3.674c-3.794.261.156-9.885.156-9.885h5.935a46.413,46.413,0,0,1-.887,6.212",
    transform: "translate(-86.326 -136.045)",
    fill: "#070540"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M75.739,138.91s-.548-6.318,1.174-8.959c1.592-2.444,15.3-3.538,17.71.5,3.2,5.361-.229,15.55-.229,15.55s-16.866,9.651-18.655-7.089",
    transform: "translate(28.204 47.63)",
    fill: "#d14122"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M79.352,149.451s-.213,2.276-.161,2.693,7.364,4.61,9.242,5.392c0,0,4.85-16.224,4.641-16.172s-13.722,8.086-13.722,8.086",
    transform: "translate(29.519 52.7)",
    fill: "#ffb9a0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M75.72,137.36c.007.228.75,14.92.946,16.563s4.61,2.217,6.644,1.316,6.876-4.342,7.43-5.164a11.124,11.124,0,0,0,.943-2.973s-.078,1.082,1.487.756a4.839,4.839,0,0,0,3.168-3.69c.2-3.587-3.56-4.161-4.617.717-.106.489-1.441.756-1.408.379s.383-4.344.427-5.048-1.483-1.487-1.522-2.151,1.135-5.243.822-5.985-5.252,1.487-9.531.548-4.9.862-4.788,4.733",
    transform: "translate(28.224 49.18)",
    fill: "#ffe5cf"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M76.038,143.535c3.987-1.008,7.9,3.8,14.373.619.117-1.338.3-3.443.328-3.939.044-.7-1.481-1.487-1.521-2.151s1.135-5.243.821-5.987-5.251,1.487-9.53.548-4.9.863-4.788,4.735c0,.1.143,2.9.317,6.175",
    transform: "translate(28.224 49.18)",
    fill: "#ffb9a0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M97.355,145.868s.671-4.216-2.109-3.873c-6.2.765-15-4.831-20.062-3.852,0,0-.94-7.036,4.173-10.172,5.53-3.391,16.575-1.369,18.962,5.477a16.245,16.245,0,0,1-.965,12.42",
    transform: "translate(28.003 47.106)",
    fill: "#070540"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M93.475,139.644a12.7,12.7,0,0,1-6.58,1.177c-3.448-.43-7.3-3.989-14.612-3.756l-.3-.626s3.525-.371,4.368-.605a14.088,14.088,0,0,1,7.095.391c2.881.879,10.028,2.3,10.028,2.3Z",
    transform: "translate(26.835 50.532)",
    fill: "#070540"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M93.475,138.831a11.633,11.633,0,0,1-6.58,1.432c-3.448-.43-7.6-3.756-14.911-3.521,0,0,3.1-1.369,4.368-1.721a14.088,14.088,0,0,1,7.095.391c3.208.979,8.4,3.083,10.028,3.42",
    transform: "translate(26.835 50.229)",
    fill: "#6b78b7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M137.89,170.939c-.56-1.27-2.342-1.715-3.981-.993s-2.514,2.339-1.953,3.609,2.342,1.715,3.981.993,2.514-2.339,1.953-3.609",
    transform: "translate(49.129 63.226)",
    fill: "#ff946e"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M394.212,192.167l-4.258,1.58,7.745,20.875,4.258-1.58,4.258-1.579-7.745-20.876Z",
    transform: "translate(145.372 71.05)",
    fill: "#acb3d8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M400.381,207.57l-6.2,2.3,1.44,3.879,6.2-2.3,6.2-2.3-1.44-3.879Z",
    transform: "translate(146.948 76.523)",
    fill: "#070540"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M393.433,189.441l-5.25,1.948,1.44,3.879,5.25-1.948,5.248-1.947-1.439-3.881Z",
    transform: "translate(144.712 69.896)",
    fill: "#070540"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M368.648,165.588l-.026-.023c.043.113.091.217.132.329-.037-.1-.073-.2-.106-.306",
    transform: "translate(137.42 61.721)",
    fill: "#6b78b7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M405.219,162.08c-.117-.356-.239-.711-.371-1.065-4.567-12.311-16.225-19.341-26.036-15.7s-14.063,16.572-9.5,28.884c.132.354.27.7.413,1.049l-.021.008c6.671,17.979,22.636,18.755,27.511,31.727l2.214-.821-.931-2.044c-2.651-5.332-7.033-8.577-11.643-11.99-1.126-.835-2.26-1.676-3.38-2.556a15.893,15.893,0,0,0,20.656-7.664c-.275,1.4-.585,2.776-.894,4.142-1.269,5.594-2.474,10.912-1,16.684l.642,2.15,2.2-.815c-4.766-13.013,6.831-24.014.159-41.994Zm-10.673,25.642c-8.6,3.189-18.938-3.24-23.053-14.332s-.469-22.712,8.127-25.9,18.938,3.24,23.053,14.332.47,22.711-8.127,25.9",
    transform: "translate(136.994 53.814)",
    fill: "#6b78b7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M394.5,156a.27.27,0,0,1,0-.033c.041.113.074.222.114.334-.038-.1-.078-.2-.118-.3",
    transform: "translate(147.068 58.142)",
    fill: "#6b78b7"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(506.793 200.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 37.38,
    height: 0.857,
    transform: "translate(-6.342 10.987) rotate(-20.356)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 37.38,
    height: 0.857,
    transform: "translate(-5.345 13.674) rotate(-20.356)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 37.38,
    height: 0.857,
    transform: "translate(-4.348 16.36) rotate(-20.356)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 37.38,
    height: 0.857,
    transform: "translate(-3.351 19.046) rotate(-20.354)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 37.38,
    height: 0.857,
    transform: "translate(-2.354 21.733) rotate(-20.354)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 37.38,
    height: 0.857,
    transform: "translate(-1.358 24.42) rotate(-20.354)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 37.38,
    height: 0.857,
    transform: "translate(-0.36 27.108) rotate(-20.356)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 37.38,
    height: 0.857,
    transform: "translate(0.636 29.794) rotate(-20.354)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 37.38,
    height: 0.857,
    transform: "translate(1.633 32.48) rotate(-20.354)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 37.38,
    height: 0.857,
    transform: "translate(2.63 35.167) rotate(-20.354)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 37.38,
    height: 0.857,
    transform: "translate(3.627 37.855) rotate(-20.356)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 37.38,
    height: 0.857,
    transform: "translate(4.624 40.542) rotate(-20.354)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 37.38,
    height: 0.857,
    transform: "translate(5.621 43.228) rotate(-20.354)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 0.857,
    height: 60.805,
    transform: "matrix(0.938, -0.348, 0.348, 0.938, -5.636, -3.438)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 0.857,
    height: 60.805,
    transform: "matrix(0.938, -0.348, 0.348, 0.938, -2.715, -4.521)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 0.857,
    height: 60.805,
    transform: "matrix(0.938, -0.348, 0.348, 0.938, 0.205, -5.605)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 0.857,
    height: 60.805,
    transform: "matrix(0.938, -0.348, 0.348, 0.938, 3.126, -6.688)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 0.857,
    height: 60.805,
    transform: "matrix(0.938, -0.348, 0.348, 0.938, 6.046, -7.772)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 0.857,
    height: 60.805,
    transform: "matrix(0.938, -0.348, 0.348, 0.938, 8.967, -8.855)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 0.857,
    height: 60.805,
    transform: "matrix(0.938, -0.348, 0.348, 0.938, 11.887, -9.939)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 0.857,
    height: 60.805,
    transform: "matrix(0.938, -0.348, 0.348, 0.938, 14.807, -11.022)",
    fill: "#070540"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 0.857,
    height: 60.805,
    transform: "matrix(0.938, -0.348, 0.348, 0.938, 17.728, -12.106)",
    fill: "#070540"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    clipPath: "url(#clip-path)"
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M319.865,288.177s-2.595,6.423-4.818,6.423-8.524-2.209-14.206-1.723-28.414,12.1-40.026,11.976l-8.153,18.778s15.443-6.054,27.177-7.906,45.833-2.718,51.392-4.695,17.3-27.92,17.3-27.92Z",
    transform: "translate(94.19 105.542)",
    fill: "#ffd2b3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M302.2,288.177a27.106,27.106,0,0,1-2.14,4.123c1.584-.478,5.476,1.561,9.8,5.946,3.282,3.329,6.541,6.053,10.069,5.6a201.333,201.333,0,0,0,10.933-20.737Z",
    transform: "translate(111.859 105.542)",
    fill: "#ffb98b"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M260.155,299.829s5.6,1.73,22.385-5.337c0,0,8.746,6.985,3.394,16.7,0,0-11.53,1.647-19.108,4.283S252,320.254,252,320.254Z",
    transform: "translate(93.945 109.785)",
    fill: "#e6e8f4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M267.17,295.62s5.641,4.118,5.806,8.565c.145,3.906-4.344,5.457-6.2,9.286s-.185,5.745-5.5,7.6-10.5.68-17.481,4.632-15.257,0-15.257,0Z",
    transform: "translate(85.2 110.205)",
    fill: "#070540"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M243.755,323.486c9.888-6.786,11.057-11.8,15.319-14.639s9.512-7.6,8.894-11.8c-.163-1.113-2.991-3.486-3.727-3.989-2.037-1.4-37.687,31.282-37.654,33.153a32.2,32.2,0,0,0,2.838,1.85c2.7,1.1,8.687-.7,14.331-4.577",
    transform: "translate(84.47 109.234)",
    fill: "#e6e8f4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M241.662,322.085c9.888-6.786,11.056-11.8,15.319-14.639s9.512-7.6,8.894-11.8-6.054-3.9-10.624-.375-3.336,6.8-11.983,9.516-13.1,9.266-15.2,13.219c-.884,1.665-3.078,6.709-1.544,8.154,2.107,1.985,8.833.247,15.134-4.077",
    transform: "translate(84.25 109.066)",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M358.369,275.5s17.953.165,23.225.988,8.73,12.354,13.507,15.813,14.331,5.929,24.213,18.612,9.224,14.166,9.224,14.166l14.825-1.153s-50.239-62.757-54.357-66.052-24.872-7.906-24.872-7.906-4.282,21.083-5.764,25.531",
    transform: "translate(133.597 93.185)",
    fill: "#ffd2b3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M378.081,265.6c.763-2.8,3.057-8.568,1.767-11.519-7.2-2.225-15.714-4.117-15.714-4.117s-4.283,21.083-5.764,25.53c0,0,8.064.074,14.97.372a41.829,41.829,0,0,0,4.742-10.266",
    transform: "translate(133.597 93.186)",
    fill: "#ffb98b"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M408.309,302.1c1.838,3.023,1.612,3.542,1.612,3.542l14.823-1.153s-.693-.868-1.914-2.389Z",
    transform: "translate(152.215 112.621)",
    fill: "#ffd2b3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M394.508,289.165c-.22-.31,8.535-8.565,10.345-8.483s18.367,22.9,20.508,25.119-11.932,3.844-13.707,2.581-4.985-6.62-9.682-11.393c-5.538-5.627-7-7.165-7.464-7.825",
    transform: "translate(147.068 104.636)",
    fill: "#e6e8f4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M405.895,301.293a10.862,10.862,0,0,0,9.379,1.717c5.25-1.606,1.027-6.2.772-8.308s1.111-2.24,3.067-.283c2.115,2.115,20.5,10.506,25.069,11.555s5.869,4.2,5.683,5.56-9.883,2.409-19.89,3.027-25.262.432-25.88-.309-.154-12.716,1.8-12.959",
    transform: "translate(150.548 109.24)",
    fill: "#070540"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M449.568,306.757l0-.01c-1.546,1.2-10.45,2.132-19.635,2.7-9.688.6-24.3.442-25.778-.24a3.6,3.6,0,0,0-.021,2.277c.618.741,15.791,1.075,25.8.457s19.7-1.668,19.889-3.027a5.638,5.638,0,0,0-.25-2.158",
    transform: "translate(150.594 114.353)",
    fill: "#e6e8f4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M304.338,251.371s-4.448,6.917-1.812,19.93.824,31.486-2.471,34.438c0,0,4.777,5.449,14.66,2.142s16.637-7.754,22.566-8.248c0,0,1.812-15.319,1.318-20.095,0,0,36.9,6.259,40.191,5.929s17.671-20.755,17.671-29.155c0,0-25.567-10.377-40.561-15.318s-51.562,10.377-51.562,10.377",
    transform: "translate(111.858 89.475)",
    fill: "#5bcfde"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(413.55 329.486)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M355.456,240.994c-14.995-4.942-51.562,10.377-51.562,10.377s-4.447,6.917-1.811,19.93a68.278,68.278,0,0,1,1.2,10.836c1.927-7.658,58.507-3.587,56.9-39.53-1.656-.581-3.245-1.124-4.729-1.613",
    transform: "translate(-301.247 -240.011)",
    fill: "#5bcfde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M331.738,283.415c.465-4.832.965-11.231.675-14.024,0,0-10.09-1.649-14.99-2.142s14.955,10.1,14.314,16.166",
    transform: "translate(-295.506 -229.864)",
    fill: "#5bcfde"
  }))))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M367.617,205.9s29.954-2.656,32.547-3.459,7.475-7.535,8.34-8.153,6.835-.206,7.865,0,.288,3.83.288,3.83,1.863,4.972,1.853,6.362c-.007.914-.906,3.4-1.853,3.274s-.453-1.318-1.441-1.524-2.43,3.418-3.624,4.077-2.8.782-5.435.412S386.2,219.06,381.2,219.863s-19.024-.432-20.136-.432,2.35-13.147,6.551-13.528",
    transform: "translate(134.525 72.309)",
    fill: "#ffd2b3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M369.051,202.568l-1.435.129c-4.2.379-7.663,13.526-6.551,13.526.526,0,3.934.276,7.911.483-.57-.982,1.807-7.07.074-14.138",
    transform: "translate(134.524 75.516)",
    fill: "#ffb98b"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M403.371,207.756c.947.124,1.846-2.36,1.853-3.274.01-1.389-1.853-6.362-1.853-6.362s.741-3.624-.288-3.83a37.9,37.9,0,0,0-6.587-.275c.534-.036,2.216-.043,2.18,1.345-.041,1.647,2.265,5.6,2.883,6.3s.863,3.141-.5,5.093v0c.314-.361.61-.582.873-.527.988.206.494,1.4,1.441,1.524",
    transform: "translate(147.811 72.309)",
    fill: "#ffb98b"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M336.461,192.812c.342-.659,17.3-4.819,18.777-5.641s2.636-4.345,3.686-5.766,5.825-5.009,6.237-6.039.476-1.846,1.257-1.846c.883,0,1.462,1.819,1.185,3.741s-3.015,4.176-3.324,4.764c0,0,6.165-.464,7.246-.063s.574,1.51-.08,1.75c-1.056.39-6.19.627-6.467.968s7.572-.067,8.312.206a1.085,1.085,0,0,1-.159,2.048c-.9.185-6.322.627-6.816.813s7.526-.227,8.452.021.9,1.915-.309,2.132-8.029.772-8.37,1.05,7.944,1.236,8.469,1.719.118,1.739-1.117,1.863-7.351-.463-7.876-.371-4.757,2.039-6.578,1.947a22.108,22.108,0,0,0-3.116-.329c-4.382.795-17.016,6.876-17.761,6.876-.84,0-2.36-8.466-1.647-9.842",
    transform: "translate(125.362 64.687)",
    fill: "#ff946e"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M351.349,184.37c-5.466,1.553-14.637,3.915-14.887,4.4-.712,1.376.806,9.842,1.646,9.842.636,0,9.87-4.4,15.311-6.2a17.936,17.936,0,0,1-2.07-8.04",
    transform: "translate(125.362 68.732)",
    fill: "#f07d18"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M342.825,177.943s-6.011-7.268-14.989-4.221-13.178,15.422-13.425,31.812c-.2,13.261,2.306,39.078-1.4,47.6s-12.107,19.767-13.466,24.831c0,0,13.176,20.95,34.714,15.813,29.525-7.041,23.1-46.326,26.4-64.028,6.084.483,16.718,3.248,20.548,3.619s10.381-14.083,9.269-19.642a182.194,182.194,0,0,1-24.421-9.581,38.443,38.443,0,0,1-15.95-14.429Z",
    transform: "translate(111.669 64.484)",
    fill: "#6b78b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(452.545 253.662)",
    opacity: 0.33,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M329.66,186.906c11.684,13.146,25.681,17.419,33.367,16.52-2.884-1.2-5.543-2.4-8.019-3.594a38.7,38.7,0,0,1-16.133-14.517l-.332-.537c-.833.947-9.157,1.82-8.883,2.128",
    transform: "translate(-329.653 -184.778)",
    fill: "#6b78b7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(439.28 237.554)",
    opacity: 0.44,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M335.2,177.917a15.239,15.239,0,0,0-9.187-4.873c2.428.463,4.22,5.774.5,6.561-3.8.8-7.548,3.049-6.268,2.523,4.42-1.813,8.945-2,6.72-1.156-2.243.847-3.587,2.343-2.891,2.207,4.18-.813,7.211.025,6.459.773a23.019,23.019,0,0,0,1.829,2.426c.077,0,2.047-2.763,4.158-5.759Z",
    transform: "translate(-319.99 -173.044)",
    fill: "#6b78b7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(461.339 293.93)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M336.346,214.787c-2.231,1.148,9.255,12.425,8.962,22.328.616-8.628.647-16.846,1.735-22.7-.689-.147-8.463-.778-10.7.371",
    transform: "translate(-336.059 -214.111)",
    fill: "#6b78b7"
  }))))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M327.759,181.76s3.416-.459,4.67-2.836l18.765,9.452c-6.119-.688-9.858,4.518-11.22,6.053-1.875,2.113-14.723-7.567-12.215-12.668",
    transform: "translate(122.066 66.702)",
    fill: "#ffb98b"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M334.81,186.1s-2.57,2.728-3.131,2.512-1.366-2.294-1.527-2.769,2.3-2.2,2-7.738-.865-12.366-.432-13.447,21.3.248,22.541.923c.664.36-.929,8.275-.71,9.335s-10.417,13.709-10.417,13.709Z",
    transform: "translate(123.076 61.232)",
    fill: "#070540"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M334.995,179.393c-2.434.106-2.052,2.7-1.594,4.12.627,1.945,2.619,3.834,3.69,2.623a23.7,23.7,0,0,0,1.355,4.265c.865,1.9,9.512,5.65,11.818,4.44,1.731-.909,1.584-10.867,1.844-12.827s1.211-2.969,1.24-3.805a53.2,53.2,0,0,0-1.009-5.707c-.231-1.1-2.622,1.067-5.793,0s-8.157-3.834-7.869-3.315c.21.379,4.611,2.306,4.871,3.171s-1.355,4.669-1.355,5.245-1.874.605-2.076,1.211-.4,4.44-.46,4.9-1.557.2-1.586-.2-.424-4.235-3.076-4.12",
    transform: "translate(124.163 63.048)",
    fill: "#ffd2b3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M150.752,151.654s2.555,6.61,27.12,13.655,27.942-7.7,27.942-7.7l-.829-16.721s-46.881-6.4-47.2-6.82-6.293,8.952-7.037,17.581",
    transform: "translate(56.199 49.976)",
    fill: "#acb3d8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M151.351,197.515s-2.081,19.006-1.459,23.922,27.785,29.644,32,31.75c0,0,9.684-9.251,9.2-10.487S172,222.794,170.206,220.211s.85-18.518.85-18.518Z",
    transform: "translate(55.835 73.632)",
    fill: "#450603"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M182.435,229.584c2.6,3.713,12.705,20.824,18.442,26.455,0,0-1.665,7.865-5.258,10.15-.769.487-4.363-2.118-4.991-1.941a114.293,114.293,0,0,0-7.881-11.7,128.125,128.125,0,0,0-10.465-11.618c-1.612-1.569,9.108-12.842,10.153-11.349",
    transform: "translate(64.164 85.537)",
    fill: "#e6e8f4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M207.849,253.883c.409.648-8.227,19.772-12.79,25.583-1.9,2.42-6.893,6.923-7.144,6.488a9.7,9.7,0,0,1-1.211-5.046c.225-1.737,1.948-12.715,1.481-15.352s-3-7.263-5.219-8.72a12.607,12.607,0,0,1,2.33-.063c1.554.067,4.819,2.744,4.983,2.257.227-.67-2.438-4.271-2.592-6.1s5.863-6.172,4.854-7.762c.833-.869,1.819.236,4.823,3.113,1.38,1.322,8.4,2.288,10.485,5.6",
    transform: "translate(68.208 91.29)",
    fill: "#6b78b7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M193.566,276.955c4.333-5.519,12.332-23.026,12.778-25.336a4.08,4.08,0,0,1,1.407,1.619c.416.644-8.227,19.772-12.79,25.583-1.9,2.42-6.893,6.923-7.144,6.488a9.159,9.159,0,0,1-.847-2.07,41.459,41.459,0,0,0,6.6-6.283",
    transform: "translate(69.701 93.802)",
    fill: "#070540"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(251.174 340.322)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M185.3,255.646c1.555.066,4.819,2.744,4.983,2.256.227-.67-2.438-4.269-2.59-6.1-.076-.9,1.345-2.411,2.687-3.9,1.1,8.5,8.763,17.076,13.256,19.8-2.444,4.942-5.195,9.977-7.177,12.5-1.9,2.42-6.893,6.923-7.144,6.488a9.185,9.185,0,0,1-.847-2.07c-.3.2-.5.281-.548.2a9.7,9.7,0,0,1-1.211-5.046c.225-1.737,1.948-12.715,1.481-15.352s-3-7.265-5.219-8.72a12.61,12.61,0,0,1,2.33-.063",
    transform: "translate(-182.966 -247.905)",
    fill: "#6b78b7"
  }))))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M183.671,212.673c.3.542-.5,4.879.255,7.734s9.991,30.484,10.576,43.135l-13.924,3.064s-17.5-39.185-18.3-44.043-.8-15.219-.8-15.219Z",
    transform: "translate(60.196 77.296)",
    fill: "#691813"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M161.978,220.149c-.5-5.233-.5-12.805-.5-12.805l22.2,5.329c.269.491-.356,4.1.088,6.9-6.746-2.256-15.394-2.415-21.781.574",
    transform: "translate(60.196 77.296)",
    fill: "#450603"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M190.862,247.679c.361,5.567,1.712,29.039,4.154,38.629,0,0-5.223,6.011-10.26,6.506-1.916.188-4.558-4.076-5.77-4.412a140.481,140.481,0,0,0-.822-17.344,157.634,157.634,0,0,0-3.591-18.909c-.695-2.68,16.144-6.709,16.29-4.47",
    transform: "translate(65.072 92.09)",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M204.953,288.206c.016.945-5.292,4.9-10.053,9.531-3.215,3.126-8.157,9.806-16.67,13.007-3.546,1.332-12.215-.46-12.2-1.078a11.922,11.922,0,0,1,1.949-6.084c1.345-1.683,10.17-12.136,11.363-15.208s.314-9.379-1.09-12.328c0,0,3.7-.4,5.292.66s3.805,5.521,4.29,5.114c.666-.56.162-6.051,1.167-8.069s8.08-1.62,7.748-3.87c1.577-.571,1.959,1.234,3.282,6.179.608,2.272,4.839,7.328,4.923,12.145",
    transform: "translate(61.894 100.572)",
    fill: "#6b78b7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M178.31,305.64c8.511-3.2,13.453-9.881,16.671-13.006,4.294-4.176,9.023-7.8,9.9-9.163v.007a11.478,11.478,0,0,1,.342,3.269c-.1.939-6.081,5.417-10.842,10.045-3.214,3.125-8.157,9.806-16.67,13.006-3.546,1.333-11.9-.445-11.893-1.063a19.588,19.588,0,0,1,.292-4.171c-.015.616,8.657,2.409,12.2,1.076",
    transform: "translate(61.815 105.676)",
    fill: "#070540"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M202.088,155.619s-.56,6.47,0,8.643c0,0-37.826,5.449-40.08-11.774-.221-1.693-.675-12.855-1.263-13.079,0,0,39.856,7.508,41.344,16.21",
    transform: "translate(59.924 51.971)",
    fill: "#691813"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M161.834,150.3c-.248-3.781-.629-10.716-1.091-10.892,0,0,39.856,7.506,41.346,16.21,0,0-.055.619-.111,1.538-11.427-7.895-40.143-6.856-40.143-6.856",
    transform: "translate(59.924 51.971)",
    fill: "#450603"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M166.647,147.441c.018,8.013-10.73,34.888-18.788,70.92,1.329,5.06,14.105,5.325,14.105,5.325s-.551,5.247-.677,7.85c2.715,6.259,25.645,8.241,29.083,5.142,1.634-5.413,6.208-26.5,7.773-32.145s9.209-15.353,10.9-24.47.074-20.376-2.4-22.39c-.706,4.987-39.247.478-40-10.231",
    transform: "translate(55.121 54.965)",
    fill: "#6b78b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(219.716 202.406)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M160.05,157.776c1.284-4.672,2.058-8.187,2.052-10.334.752,10.709,39.293,15.217,40,10.23,2.309,1.882,3.871,11.836,2.687,20.573-4.655-7.6-26.734-19.163-44.738-20.468",
    transform: "translate(-160.05 -147.441)",
    fill: "#6b78b7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(204.501 248.473)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M148.967,208.008h0c6.765,2.29,17.956-32.2,16.848-26.338-1.768,9.356-4.264,29.507-4.264,29.507s-8.852-.187-12.584-3.168",
    transform: "translate(-148.967 -180.998)",
    fill: "#6b78b7"
  }))))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M194.731,35.4c-5.825-.42,1.3-17.764,1.673-21.236.184-1.7-3.987-.537-6.477,1.142s-2.629,6.554-2.629,6.554l-1.986,15.092s8.881-.13,9.419-1.553",
    transform: "translate(69.083 4.972)",
    fill: "#450603"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(254.395 18.308)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M194.731,35.4c-5.825-.42,1.3-17.764,1.673-21.236.184-1.7-3.987-.537-6.477,1.142s-2.629,6.554-2.629,6.554l-1.986,15.092s8.881-.13,9.419-1.553",
    transform: "translate(-185.312 -13.336)",
    fill: "#450603"
  }))))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M186.291,17.719a20.673,20.673,0,1,1,17.5,23.417,20.674,20.674,0,0,1-17.5-23.417",
    transform: "translate(69.368 0)",
    fill: "#f07d18"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M196.763,9.668a26.484,26.484,0,0,1,3.313-4,35.706,35.706,0,0,1-4.541-2.4,21.1,21.1,0,0,1,1.937-1.111,34.1,34.1,0,0,0,4.2,2.073,22.266,22.266,0,0,1,3.749-2.5A20.533,20.533,0,0,1,209.4.131c.1.012.2.021.3.036a20.7,20.7,0,0,1,4.418,1.149,18.673,18.673,0,0,0-7.8,2.128,20.227,20.227,0,0,0-2.52,1.587,63.548,63.548,0,0,0,8.687,2.106c4.758.907,9.14,1.748,12.974,4.714a20.588,20.588,0,0,1,1.415,4.077c-4.05-4.84-8.959-5.779-14.753-6.885a60.139,60.139,0,0,1-10.085-2.57A23.929,23.929,0,0,0,198.7,10.28c9.216,3.094,19.628,9.441,26.7,19.29a20.138,20.138,0,0,1-1.035,1.892c-6.955-10.175-17.551-16.607-26.721-19.58A35,35,0,0,0,193.92,20.6c3.19,1.572,5.534,4.349,8.05,7.338,3.289,3.9,6.942,8.234,13.311,11.512a20.73,20.73,0,0,1-2.369.91c-5.849-3.373-9.419-7.6-12.425-11.172-2.433-2.888-4.47-5.3-7.055-6.7a57.264,57.264,0,0,0-1.418,12.631,20.766,20.766,0,0,1-1.885-2.209,57.053,57.053,0,0,1,1.5-11.2,12.855,12.855,0,0,0-5.538-.412c-.021-.642-.011-1.292.029-1.944a14.827,14.827,0,0,1,6,.52,37.259,37.259,0,0,1,3.613-8.573,37.774,37.774,0,0,0-6.74-1.27,20.549,20.549,0,0,1,1.182-1.77,42.586,42.586,0,0,1,6.589,1.4",
    transform: "translate(69.37 0.049)",
    fill: "#070540"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M188.414,96.33s-3.395-6.274-4.534-8.561,13.609-44.406,14.756-46.119c2.917-4.357,10.671-5.232,10.995-7.361.191-1.248-.748-1.713-2.139-1.89-2.493-.318-4.975.605-6.432.894s-5.3.793-6.324-.158c-1.642-1.527-1.384-8.112-1.3-9.847s.373-4.78-.357-5.331c-.807-.608-2.162.438-2.739,4.431s-.5,16.114-1.318,18.325S177.89,62.564,175.833,66.428a172.577,172.577,0,0,0-7.3,18.054c-.551,2.084,10.325,23.574,11.706,26.1s9.177-11.872,8.176-14.255",
    transform: "translate(62.82 6.635)",
    fill: "#450603"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(237.825 98.558)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M184.285,71.794c1.2,2.247,2.365,4.407,2.365,4.407,1,2.383-6.8,16.784-8.176,14.254-.582-1.064-2.847-5.491-5.232-10.414a24.228,24.228,0,0,0,11.043-8.246",
    transform: "translate(-173.242 -71.794)",
    fill: "#450603"
  }))))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M199.864,90.755c-.465-.185-11.2-10.824-14.45-16.81,0,0-7.343,5.034-9.435,12.6S195.22,105.7,200.12,106.347s6.578-12.873-.255-15.592",
    transform: "translate(65.55 27.566)",
    fill: "#ffb718"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M210.664,97.716s1.636-2.862,7.45-5.3c4.423-1.856,7.7-4.916,6.4-11.308s-7.987-10.329-10.628-10.8-4.54,2.12-4.54,2.12-6.993,20.854,1.322,25.288",
    transform: "translate(77.016 26.189)",
    fill: "#330300"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M196.615,81.141c-.4,1.749,3.13,4.706,3.227,5.24s-1.905,5.785-1.905,5.785,13.905,7.165,14.376,7.539c0,0,1.05-3.344,2.083-5.641,0,0-1.406-4.485,3.343-7.939,2.448-1.782-.141-2.433-.141-2.433s-18.592-6.065-20.982-2.552",
    transform: "translate(73.285 29.841)",
    fill: "#450603"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M212.139,87.979c1,1.214,4.7,3.053,6.574.353s-.894-3.988-4.348-3.366c-.545.1,3.363-4.083,3.4-4.518.027-.286-.014-1.9.482-2.42,1.069-1.135,2.387-1.708,2.01-2.8-.848-2.456-3.571-3.528-5.1-3.63s-6.058,1.411-9.465,3.831c-1.307.928-8.377,7.456-9.091,8.866,1.785-1.461,5.69,2.875,10.127,4.521a5.393,5.393,0,0,0,5.406-.835",
    transform: "translate(73.293 26.689)",
    fill: "#691813"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M234.541,103.745s-1.675,8-13.486,31.013c-7.59,14.782-14.9,28.8-15.194,39.494.478-2.07-53.233-16.935-55.061-5.959,0,0-1.914-11.78,6.946-24.73s33.275-48.866,44.041-53.4,32.755,13.587,32.755,13.587",
    transform: "translate(56.152 33.338)",
    fill: "#e6e8f4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M216.887,113.691c-21.332-2.589-36.271,10.955-49.929,8.057,10.194-13.961,22.079-28.782,28.739-31.589,8.5-3.582,23.974,6.946,30.126,11.547-.2.038-4.493,12.525-8.937,11.986",
    transform: "translate(62.241 33.338)",
    fill: "#acb3d8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M182.675,104.621s-2.772-.11-3.244-10.662S197.64,98.67,197.64,98.67s-8.912,8.116-14.965,5.951",
    transform: "translate(66.887 33.641)",
    fill: "#ffb718"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M196.531,103.76s-6.89-1.557-9.044-3.491-16.074-32.155-16.935-34.4,2.623-5.053,3.6-6.742c1.028-1.786,4.828-4.337,5.914-5.219s-.982-2.234-2.216-1.943c-1.207.283-5.258,2.693-6.294,2.667s-1.565-4.72-1.667-6.606.858-12.276.9-13.434a1.169,1.169,0,0,0-2.282-.329c-.45,1.392-2.051,11.021-2.43,11.632s-.979.441-1,.022.335-12.392.389-13.341-1.779-1.8-2.242-.324-1.58,12.67-1.89,13.081-3.587-10.878-3.923-11.717-2.24-.615-2.162.853,3.23,11.909,2.956,12.66-5.314-5.553-5.983-6.108-2.492-.027-1.522,1.61,4.4,6.419,5.048,7.678,1.146,8.487,1.893,10.8c.56,1.735,2.8,3.982,3.388,4.776s9.751,37.9,11.6,41.806,27.324,16.493,29.349,18.033,4.909-18.43-5.439-21.963",
    transform: "translate(56.074 11.726)",
    fill: "#691813"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(248.517 115.079)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M183.5,83.828c.964.259,1.617.408,1.617.408,10.348,3.534,7.463,23.5,5.439,21.963-.751-.571-4.728-2.662-9.527-5.265,4.732-2.444,2.56-16.837,2.471-17.106",
    transform: "translate(-181.03 -83.828)",
    fill: "#450603"
  }))))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M223.13,100.706c-1.267-5.488-6.351-10.466-16.9-12.178s-21.395-4.4-21.395-4.4c5.295,4.389,4.517,25.4-3.042,22.777,0,0,20.847,8.193,29.564,8.765s12.849-10.3,11.773-14.962",
    transform: "translate(67.771 31.361)",
    fill: "#feda00"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M212.842,267.141s-1.893.417-2.621.6c-.428.1-.442,2.013-.168,2.457s3.028.8,3.028.8.2-3.657-.24-3.855",
    transform: "translate(78.238 99.588)",
    fill: "#070540"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M212.871,270.809s-1.851.577-2.56.815c-.419.14-.269,2.044.043,2.463s3.083.542,3.083.542-.107-3.661-.566-3.821",
    transform: "translate(78.307 100.956)",
    fill: "#070540"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M214.337,283.461s-1.815,0-2.516.018c-.413.01-.809,1.753-.647,2.214s2.608,1.341,2.608,1.341.92-3.3.555-3.573",
    transform: "translate(78.71 105.672)",
    fill: "#070540"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M213.19,289.9s-1.457.638-2.013.9c-.328.152-.034,1.69.258,2s2.562.161,2.562.161-.42-2.973-.807-3.061",
    transform: "translate(78.672 108.072)",
    fill: "#070540"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M213.9,293.6s-.876,1.326-1.2,1.846c-.194.306.99,1.389,1.448,1.385a9.261,9.261,0,0,0,2.095-1.1s-1.967-2.269-2.341-2.132",
    transform: "translate(79.284 109.45)",
    fill: "#070540"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M259.479,256.813c1.065,5.973-25.7,20.46-33,35.345-.618,1.262-4.368,8.388-5.634,8.89-3.437,1.367-5.218-3.838-5.5-5.821-.769-5.34-.106-16.931,5.272-20.927,5.613-4.17,12.185-14.4,15.425-20.91,2.618-5.259,9.846-15.485,15.33-15.577s8.106,19,8.106,19",
    transform: "translate(80.181 88.655)",
    fill: "#e6e8f4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M234.242,243.669c.431-.544.873-1.079,1.326-1.6-.048.17-.1.334-.139.52-1.927,9.854,3.558,19.675,8.18,22.106a5.606,5.606,0,0,0,.82.351c-.286.244-.581.493-.876.743-.139-.062-.276-.119-.416-.194-4.695-2.471-10.223-12.06-8.9-21.93",
    transform: "translate(87.249 90.243)",
    fill: "#6b78b7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M224.539,279.056c1.548-3.295-2.5-6.227-5.7-2.472l-.3,7.574s4.191.951,4.114.835,1.894-5.936,1.894-5.936",
    transform: "translate(81.466 102.452)",
    fill: "#6b78b7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M222.04,264.392c-1.608.942-6.661-.552-9.851,2.383-2.79,2.567,1.727,16.344,1.13,19.6s-2.721,7.331-1.841,13.8,5.818,9.523,9.9,8.687c3.085-.633,3.116-10.813,4.154-17.216,1.148-7.069,3.932-10.37,3.932-10.37s-3.418-.15-5.6,5.406c0,0,1.65-3.985-1.426-6.854s-5.024-10.219-.4-15.444",
    transform: "translate(78.759 98.563)",
    fill: "#acb3d8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M238.781,219.766s3.461,2,19.723,1.144,9.986-8.9,3.122-9.5-22.974,3.917-22.845,8.355",
    transform: "translate(89.016 78.793)",
    fill: "#070540"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M277.814,219.925s-4.587,16.1-8.933,23.659-5.123,12.389-7.641,14.825c-2.044,1.98-5.318,4.029-11.407,10.237-3.344,3.411-11.725-7.854-9.77-17.846.77-3.94,5.026-3.475,5.626-7.2s-.774-23.829-1.043-27.858,31.188-8.94,33.168,4.186",
    transform: "translate(89.385 78.807)",
    fill: "#ffd2b3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M243.95,225.718c-.255-4.477-.524-8.425-.627-9.98-.27-4.029,31.188-8.938,33.167,4.186,0,0-.388,1.365-1.043,3.476-8.931-4.779-27.71-.192-31.5,2.319",
    transform: "translate(90.708 78.807)",
    fill: "#ffb98b"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M278.489,171.835s7.659,25.207,7.137,37.947-3.486,26.15-3.84,26.148c.048-.428,1.113-4.438-11.47-5.015-14.318-.656-27.3,1.94-27.847,4.473-3.107-.324,4.721-12.083,2.862-31.834S228.886,176.8,228.886,176.8s3.756-3.61,2.53-7.344c0,0,37.73,6.847,47.073,2.382",
    transform: "translate(85.327 63.171)",
    fill: "#6b78b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(314.213 232.624)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M278.489,171.835s7.659,25.207,7.137,37.947-3.486,26.15-3.84,26.148c.048-.428,1.113-4.438-11.47-5.015-14.318-.656-27.3,1.94-27.847,4.473-3.107-.324,4.721-12.083,2.862-31.834S228.886,176.8,228.886,176.8s3.756-3.61,2.53-7.344c0,0,37.73,6.847,47.073,2.382",
    transform: "translate(-228.886 -169.453)",
    fill: "#6b78b7"
  }))))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M243.631,218.176s5.574,4.193,18.183-9.41c13.261-14.309-13.009-14.795-13.608-14.711s-10.448,16.862-4.574,24.121",
    transform: "translate(90.13 72.34)",
    fill: "#070540"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M275.429,186.684s20.9,17.185,25.844,24.2c1.617,2.3-.917,13.209-1.274,25.045-3.494-1.179-17.575-.4-21.8.96.987-5.229,2.971-9.619,2.964-10.866-.012-2.019-26.109-12.856-33.206-17.7s6.065-29.652,27.474-21.634",
    transform: "translate(91.715 69.004)",
    fill: "#ffd2b3"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M275.429,186.684s.835.686,2.2,1.83c-.093.027-.184.048-.28.08-11.522,3.893-16.228,14.955-17.474,26.1a114.243,114.243,0,0,1-11.916-6.371c-7.1-4.849,6.065-29.652,27.474-21.634",
    transform: "translate(91.715 69.004)",
    fill: "#ffb98b"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M282.783,192.8c2.456-2.015-43.264-28.229-52.027-23.53-7.542,4.044-3.794,21.53-1.222,29.9,4.405,14.34,13.407,19.046,19.866,28.458-1.628-1.94-1.3-6.857,7.108-13.932,9.592-8.071,10.58-20.809,26.275-20.9",
    transform: "translate(84.361 62.892)",
    fill: "#6b78b7"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M273.864,266.058c-.748-8.6-4.862-28.127-4.8-42.656.08-.45,10.414-5.5,22.689-1.023-.68,16.482-2.964,35.7-3.514,48.851-.247,5.9,2.644,13.114,2.578,14.541,0,0-9.438,6.7-19.155-9.817.906-.754,2.84-2.523,2.2-9.9",
    transform: "translate(100.306 82.215)",
    fill: "#e6e8f4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M291.407,226.645q-.031.523-.065,1.049a31.761,31.761,0,0,0-22.091.842c-.023-.365-.047-.732-.067-1.094a32.891,32.891,0,0,1,22.223-.8",
    transform: "translate(100.35 83.916)",
    fill: "#6b78b7"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M288.193,276.348a60.215,60.215,0,0,1-1.818-11.7c.007-1.457-3.263-.1-3.13,2.9.107,2.412,5.762,12.152,4.948,8.8",
    transform: "translate(105.59 98.441)",
    fill: "#6b78b7"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M274.158,272.317a21.911,21.911,0,0,1-2.861,1.66c-.594.329-2.176-1.262-1.9-1.79s1.344-3.295,1.7-3.274a10.972,10.972,0,0,1,3.057,3.4",
    transform: "translate(100.418 100.248)",
    fill: "#070540"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M281.425,279.877a19.858,19.858,0,0,1-2.811.977c-.581.189-1.706-1.488-1.371-1.907s1.75-2.681,2.065-2.6a9.892,9.892,0,0,1,2.118,3.531",
    transform: "translate(103.331 103.019)",
    fill: "#070540"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M284.227,282.313a17.737,17.737,0,0,1-2.232,1.5c-.463.3-1.83-.909-1.632-1.351s.914-2.741,1.207-2.743a8.908,8.908,0,0,1,2.658,2.6",
    transform: "translate(104.51 104.276)",
    fill: "#070540"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M287.624,285.324a15.626,15.626,0,0,1-1.859,1.494c-.387.3-1.689-.663-1.547-1.069s.6-2.494.857-2.518a7.9,7.9,0,0,1,2.549,2.094",
    transform: "translate(105.95 105.586)",
    fill: "#070540"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M291.357,286.177a15.129,15.129,0,0,1-1.273,1.816c-.269.367-1.68-.155-1.661-.555s-.108-2.383.114-2.471a7.353,7.353,0,0,1,2.82,1.209",
    transform: "translate(107.515 106.232)",
    fill: "#070540"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M271.721,269.485a21.923,21.923,0,0,1-2.861,1.66c-.593.329-2.176-1.262-1.9-1.79s1.344-3.295,1.7-3.274a10.973,10.973,0,0,1,3.057,3.4",
    transform: "translate(99.509 99.193)",
    fill: "#070540"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M295.768,282.186c-2.159-5.862-4.312-10.551-5.07-13.217-.689-2.422-7.648.82-11.172-.678-6.615-2.811-6.178-8.24-6.178-8.24-.222.043-5.93,2.42-5.957,8.143a1.918,1.918,0,0,0,.453,1.219,94.84,94.84,0,0,0,8.052,8.352c5.943,5.567,9.92,12.333,16.1,16.552s9.6,2.527,10.245,1.252-5.151-9.784-6.477-13.383",
    transform: "translate(99.682 96.945)",
    fill: "#acb3d8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M224.691,134.1s-7.317,2.688-9.029,3.457-5.392,6.891-10,11.378-10.225,10.6-10.934,12.928,1.056,7.152.5,9.325a74.82,74.82,0,0,1-2.989,8.3c-.471.931-2.179.689-2.872-.789,0,0-4.526.9-6.178-1.148-1.075-1.41-1.641-5.258-1.79-6.735s4.784-10.079,5.958-12.094,14.412-26.354,18.154-29.057,7.629-3.229,11.755-5.232c0,0,7.272,7.258,7.417,9.667",
    transform: "translate(67.626 46.388)",
    fill: "#ffd2b3"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M182.981,164.956a7.407,7.407,0,0,1-1-2.352,10.308,10.308,0,0,0,3.617-.207c2.877-.686,5.508-6.775,4.131-2.9a11.541,11.541,0,0,0-.572,6.6s-4.526.9-6.179-1.148",
    transform: "translate(67.842 58.983)",
    fill: "#ffb98b"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M209.678,124.433s7.272,7.258,7.416,9.667c0,0-7.314,2.687-9.027,3.457a7.143,7.143,0,0,0-1.914,1.8l.005-.01c1.984-2.508-.968-12.072-4.379-11.81,2.547-1.09,5.17-1.779,7.9-3.1",
    transform: "translate(75.222 46.388)",
    fill: "#ffb98b"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M276.809,139.529s3.6.277,4.74-6.245-15.16-11.139-15.16-11.139,5.018,14.826,10.419,17.384",
    transform: "translate(99.308 45.535)",
    fill: "#00b09d"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M279.708,119.131s17.822,8.627,20.5,9.338,6.1,15.545,4.536,15.469c-5.418-.264-33.988-9.655-34.859-10.3s1.587-15.923,9.825-14.506",
    transform: "translate(100.549 44.377)",
    fill: "#ffd2b3"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(392.976 169.523)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M286.26,123.488c3.569,1.643,6.764,3.052,7.78,3.321,2.677.711,6.1,15.547,4.534,15.47-1.855-.091-6.427-1.252-11.669-2.766,4.221.221.81-12.568-.645-16.025",
    transform: "translate(-286.26 -123.488)",
    fill: "#ffb98b"
  }))))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M279.708,119.131s.835.4,2.165,1.042c-2.356.318-4.673,14.479-4.265,16.2-4.305-1.418-7.445-2.527-7.725-2.735-.872-.644,1.587-15.923,9.825-14.506",
    transform: "translate(100.549 44.377)",
    fill: "#ffb98b"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M298.512,126.445s.284,1.517,2.833,4.849,1.188,8.338-1.964,9.548-7.453-1.49-8.717-5.4a28.3,28.3,0,0,1-1.248-7.814Z",
    transform: "translate(107.892 47.138)",
    fill: "#ffe5cf"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M301.405,121.469s-.316,6.322-1.594,8.655c-1.873,3.422-6.966,3.194-9.6,1.59s-3.855-6.738-3.888-7.98.437-1.863,2.379-2.243,12.7-.022,12.7-.022",
    transform: "translate(106.738 45.226)",
    fill: "#ffb98b"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M294.854,124.239s-.46,2.247.211,3.07,1.977.4,2.508-.9a26.651,26.651,0,0,0,1.157-5.142c.2-1.424-2.1-2.681-2.807-1.558s-.87,3.63-1.069,4.532",
    transform: "translate(109.862 44.465)",
    fill: "#ffe5cf"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M292.285,127.289s-.018,1.859,1.3,2.194c1.028.262,2.022-.4,2.254-1.782a58.83,58.83,0,0,0,.964-7.819c-.117-1.432-2.811-1.951-3.418-.772-.933,1.813-1.224,6.762-1.1,8.179",
    transform: "translate(108.952 44.16)",
    fill: "#ffe5cf"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M289.68,126.768s-.01,2.352,1.581,2.726c1.045.247,1.8-.717,2.037-2.125s1.17-6.886,1.054-8.342-3.123-1.7-3.738-.5c-.947,1.846-1.057,6.8-.935,8.238",
    transform: "translate(107.976 43.901)",
    fill: "#ffe5cf"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M287.537,124.847s.35,2.051,1.237,2.634,2-.225,2.117-1.635.636-5.73.4-7.156-3.225-1.41-3.73-.173c-.776,1.9-.265,4.919-.022,6.33",
    transform: "translate(107.046 43.842)",
    fill: "#ffe5cf"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M267.728,96.347s1.193-8.429-9.6-9.809c-9.084-1.138-14.16,5.292-14.105,12,.045,5.506-1.406,6.268-8.189,4.92s-15.392,2.253-15.48,10.5c-.151,14.079,6.239,17.925,20.917,20.673s23.494-15.1,21.195-23.064.673-15.7,5.26-15.223",
    transform: "translate(82.146 32.212)",
    fill: "#f07d18"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M287.63,193.728s7.629-3.23,6.1-8.52-8.817-17.87-6.9-29.361,3.653-9.191,1.365-18.99c0,0,7.666,6.094,11.742,6.927,0,0-3.488-2-2.64-9.335s4.527-10.849,6.779-12.219c0,0-11.133-4.7-17.176-8.688s-13.8-2.971-23.185-1.6c-12.6,1.842-27.151-.85-35.2,1.743s-15.152,12-23.851,17.5c-2.109,1.333,7.743,14.731,15.8,11.66,1.452-.553,7.362-4.518,8.414-5.152s7.081,3.551,9.412,17.962c1.318,8.137.645,27.364-.419,30.622s-.2,4.566,2.7,5.063,29.132,9.762,47.073,2.382",
    transform: "translate(76.186 41.278)",
    fill: "#5bcfde"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(339.258 152.014)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M274.084,138.273a66.192,66.192,0,0,1-7.97-5.373s-2.618-8.193-2.527-11.221c.091-3.006,7.365,15,10.5,16.594",
    transform: "translate(-240.996 -106.778)",
    fill: "#00b09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M271.583,133.862c-.095-.049-.189-.1-.286-.151.691.3.7.327.286.151",
    transform: "translate(-238.121 -102.167)",
    fill: "#00b09d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M247.608,111.962l.159-.019c6.139-.9,11.575-1.635,16.3-.928-2.363-.244-9.155.214-4.092,2.584,5.449,2.548,8.66,9.671,4.3,11.186s-16.472-4.621-16.472-4.621a14.994,14.994,0,0,1-.194-8.2",
    transform: "translate(-247.13 -110.733)",
    fill: "#00b09d"
  }))))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M260.305,111.825a21.135,21.135,0,0,1-5.667,1.285c.058.814,1.124,6.447.629,9.588-.645,4.09-15.521-4.184-14.984-7.121,0,0,4-7.376,2.515-12.745,0,0,19.1,8.274,17.507,8.993",
    transform: "translate(89.57 38.335)",
    fill: "#ffb98b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(332.368 141.166)",
    opacity: 0.33,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M246.865,104.941l-.007.01a1.883,1.883,0,0,0-1.028-.194,5.62,5.62,0,0,0-3.421,1.521,10.573,10.573,0,0,0-.3-3.446s2.054.89,4.754,2.109",
    transform: "translate(-242.111 -102.831)",
    fill: "#ffb98b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(336.016 146.459)",
    opacity: 0.33,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M244.768,106.687s15.142,3.12,13.86,3.7a21.021,21.021,0,0,1-5.665,1.285,15.373,15.373,0,0,1-8.194-4.985",
    transform: "translate(-244.768 -106.687)",
    fill: "#ffb98b"
  }))))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M259.353,93.022c1.721,3.431,1.587,20.615,1.363,22.338-.143,1.1-3.174,1.262-5.313.815a35.9,35.9,0,0,1-9.132-3.457c-.944-.669-1.271-3.041-1.373-4.287-.881.618-2.8-.34-3.372-2.331-.167-.844,2.251-1.632,3.293-1.314a6.8,6.8,0,0,1,1.446,2.327c-.961-7.171,5.03-7.737,4.161-13.263-.424-2.695,5.558-1.014,6.142-1.321s1.063-2.939,2.784.491",
    transform: "translate(90.037 34.027)",
    fill: "#ffd2b3"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(305.052 173.86)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M235.028,144.731c3.822,5.611,16.265,11.726,16.6,13.942s-18.822-6.142-19.333-.088a71.551,71.551,0,0,0-.673-8.857c-2.332-14.412-8.362-18.6-9.413-17.962,0,0,6.952-5.241,8.815-5.118s.178,12.472,4,18.082",
    transform: "translate(-222.213 -126.647)",
    fill: "#00b09d"
  }))))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M266.549,71.326l2.5-6.451-4.239-3.167L258.016,64.2l-2.335,5.722,4.2,3.675Z",
    transform: "translate(95.316 23.005)",
    fill: "#f4f3f3"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M255.987,69.472l2.039-4.994a.439.439,0,0,1,.254-.246l6.167-2.258a.438.438,0,0,1,.412.06l3.529,2.637a.438.438,0,0,1,.147.508l-2.2,5.674a.434.434,0,0,1-.266.255l-6,2.041a.439.439,0,0,1-.428-.085l-3.536-3.1a.436.436,0,0,1-.117-.493",
    transform: "translate(95.418 23.094)",
    fill: "#fff"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M256.7,67.689l-3.763,4.817,1.738,6.338,4.85-.567,1.371-6.912Z",
    transform: "translate(94.294 25.234)",
    fill: "#070540"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M266.57,65.3l6.942,1.02,1.532-1.749a16.14,16.14,0,0,0-11.2-4l-1.51,1.565Z",
    transform: "translate(97.795 22.577)",
    fill: "#f4f3f3"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M263.971,60.741a15.893,15.893,0,0,1,10.22,3.5.437.437,0,0,1,.051.629l-.828.946a.437.437,0,0,1-.393.144l-6.407-.94a.45.45,0,0,1-.2-.082l-3.483-2.6a.437.437,0,0,1-.054-.653l.778-.807a.444.444,0,0,1,.312-.136",
    transform: "translate(97.955 22.643)",
    fill: "#fff"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M264.419,62.134l1.509-1.565a16.176,16.176,0,0,0-9.2,3.227l.9.826Z",
    transform: "translate(95.707 22.58)",
    fill: "#070540"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M257.017,69.467l2.335-5.72-.9-.828a16.228,16.228,0,0,0-6.36,10.975l1.157.39Z",
    transform: "translate(93.98 23.456)",
    fill: "#f4f3f3"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M252.628,73.723a.438.438,0,0,1-.3-.482,15.877,15.877,0,0,1,3.756-8,16.3,16.3,0,0,1,1.973-1.9.441.441,0,0,1,.574.021l.121.114a.439.439,0,0,1,.11.486l-2.122,5.2a.4.4,0,0,1-.06.1l-3.409,4.363a.437.437,0,0,1-.485.146Z",
    transform: "translate(94.065 23.58)",
    fill: "#fff"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M253.287,71.3l-1.156-.39A16.214,16.214,0,0,0,255.014,82.3l.011-4.661Z",
    transform: "translate(93.947 26.436)",
    fill: "#f4f3f3"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M253.885,79.942a15.927,15.927,0,0,1-1.661-8.277.438.438,0,0,1,.859-.08l1.619,5.9a.479.479,0,0,1,.015.117l-.005,2.139a.438.438,0,0,1-.826.2",
    transform: "translate(94.013 26.567)",
    fill: "#fff"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M264.359,80.046l-2.651-2.321L259.059,75.4l-4.85.567L254.2,80.63a16.149,16.149,0,0,0,5.617,4.923l4.621-.623Z",
    transform: "translate(94.763 28.109)",
    fill: "#f4f3f3"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M256.813,83.164a16.017,16.017,0,0,1-2.352-2.567.447.447,0,0,1-.086-.265l.01-3.833a.437.437,0,0,1,.386-.434l3.951-.461a.442.442,0,0,1,.339.106l4.846,4.246a.442.442,0,0,1,.15.323l.062,3.977a.434.434,0,0,1-.378.439l-3.8.513a.44.44,0,0,1-.273-.051,15.955,15.955,0,0,1-2.854-1.993",
    transform: "translate(94.829 28.184)",
    fill: "#fff"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M271.083,73.359l-2.651-2.321-2.65-2.323-6.672,2.269L257.738,77.9l2.651,2.321,2.651,2.323,6.672-2.269Z",
    transform: "translate(96.083 25.616)",
    fill: "#f4f3f3"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M257.97,77.468l1.219-6.143a.438.438,0,0,1,.287-.328l5.929-2.017a.435.435,0,0,1,.428.086l4.711,4.127a.437.437,0,0,1,.14.413l-1.219,6.142a.438.438,0,0,1-.287.329l-5.929,2.015a.434.434,0,0,1-.428-.085l-4.711-4.127a.438.438,0,0,1-.14-.413",
    transform: "translate(96.166 25.707)",
    fill: "#fff"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M267.832,73l6.065-3.326,3.7,3.785-1.575,7.063-5.364,3.067-4.2-3.676Z",
    transform: "translate(99.334 25.974)",
    fill: "#f4f3f3"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M266.691,79.465l1.233-6.216a.436.436,0,0,1,.22-.3l5.335-2.925A.435.435,0,0,1,274,70.1l3.081,3.153a.437.437,0,0,1,.114.4l-1.429,6.41a.431.431,0,0,1-.21.284l-4.683,2.678a.433.433,0,0,1-.5-.051l-3.538-3.1a.439.439,0,0,1-.14-.413",
    transform: "translate(99.418 26.085)",
    fill: "#fff"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M273.04,65.036l-6.942-1.02-2.5,6.451,2.649,2.321,2.651,2.323,6.065-3.326Z",
    transform: "translate(98.268 23.865)",
    fill: "#070540"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M272.468,80.809l-4.28,4.364-6.511-.89L261.6,79.4l6.672-2.269Z",
    transform: "translate(97.523 28.755)",
    fill: "#070540"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M272.4,71.983l-1.923-6.749,1.531-1.749a16.145,16.145,0,0,1,5.443,10.581l-1.354,1.7Z",
    transform: "translate(100.832 23.667)",
    fill: "#f4f3f3"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M272.5,71.605l-1.775-6.227a.436.436,0,0,1,.091-.408l.829-.946a.437.437,0,0,1,.63-.032,15.888,15.888,0,0,1,4.817,9.671.44.44,0,0,1-.095.327l-.7.877a.436.436,0,0,1-.653.033l-3.039-3.111a.428.428,0,0,1-.107-.185",
    transform: "translate(100.918 23.812)",
    fill: "#fff"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M275,72.894l1.354-1.7a16.172,16.172,0,0,1-1.991,9.544l-.936-.78Z",
    transform: "translate(101.931 26.54)",
    fill: "#070540"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M270.679,80.644l5.365-3.067.936.778A16.229,16.229,0,0,1,266.937,86.1l-.538-1.1Z",
    transform: "translate(99.312 28.92)",
    fill: "#f4f3f3"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M266.8,84.729l3.877-3.952a.459.459,0,0,1,.1-.074l4.872-2.787a.44.44,0,0,1,.5.044l.129.107a.439.439,0,0,1,.1.564,16,16,0,0,1-9.055,6.979.438.438,0,0,1-.516-.229l-.076-.154a.434.434,0,0,1,.08-.5",
    transform: "translate(99.416 29.025)",
    fill: "#fff"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M269.422,83.232l.538,1.1a16.224,16.224,0,0,1-11.669-1.36l4.619-.625Z",
    transform: "translate(96.289 30.697)",
    fill: "#f4f3f3"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M262.408,82.527l6.061.828a.438.438,0,0,1,.034.862,15.943,15.943,0,0,1-8.415-.555.44.44,0,0,1,.085-.85l2.117-.286a.426.426,0,0,1,.118,0",
    transform: "translate(96.85 30.764)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.0c1af923e74a80fac9da97ee2e69ae2e.svg";
export { ForwardRef as ReactComponent };